<template>
    <div class="pp-models-list">
        <div v-if="models">
            <div class="pp-model-item flat" v-for="model in models" :key="`model-fav-${model.id}`">
                <div class="saved-item-action" @click="deleteFavoriteModel(model.id)">
                    <span> Elimina de la favorite </span>
                    <i class="fas fa-heart-broken"></i>
                </div>
                <div class="pp-model-item-content pp-length-flex">
                    <div class="pp-model-picture pp-length-picture no-border">
                        <img :src="model.first_listing_image_url" alt="">
                    </div>
                    <div class="pp-model-info pp-length-info">
                        <div class="pp-model-info-strip">
                            <h2 class="pp-model-item-heading">
                                <a href="javascript:void(0)" @click="openModelDetailModal(model.project.id,model.id,'favorites')">
                                    {{model.rooms_count ? model.rooms_count.name : ''}} tip {{model.model_type}}
                                </a>
                            </h2>
                        </div>
                        <div class="pp-model-info-strip">
                            <h2> Pret incepand de la:</h2>
                            <p v-if="model.total_items > 0 && model.total_items === model.items_sold">
                                --
                            </p>
                            <p v-else>
                                {{ formatPrice(model.min_price) }} ({{model.price_with_vat ? 'TVA inclus' : '+TVA'}})
                            </p>
                        </div>
                        <div class="pp-model-info-strip" v-if="model.min_credit_price">
                            <h2> Pret cu credit de la:</h2>
                            <p v-if="model.total_items > 0 && model.total_items === model.items_sold">
                                --
                            </p>
                            <p v-else>
                                {{ formatPrice(model.min_credit_price) }} ({{model.credit_price_with_vat ? 'TVA inclus' : '+TVA'}})
                            </p>
                        </div>
                        <div class="pp-model-info-strip">
                            <ul>
                                <li>
                                    <span>Suprafata totala: {{ model.min_surface }} m² </span>
                                </li>
                                <li v-if="model.terrace_surface">
                                    <span> Balcon: {{ model.terrace_surface }} m² </span>
                                </li>
                            </ul>
                        </div>
                        <div class="pp-model-info-strip" v-switch="model.type">
                            <h2 v-case="'house'"> Case disponibile</h2>
                            <h2 v-case="'apartment'"> Apartamente disponibile</h2>
                            <h2 v-case="'commercial'"> Spaţii disponibile</h2>
                            <p> {{model.available_items}} </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pp-empty-list" v-if="models.length === 0">
                <p>Momentan nu aveti modele salvate.</p>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "PublicProjectFavoriteModels",
    props: ['projectId'],
    data() {
      return {
        models: [],
        loggedIn: false
      }
    },
    async mounted() {
      let vm = this
      await this.getModels()
      this.$eventBus.$on('SAVED_FAVORITES', async function () {
        await vm.getModels()
      });
    },
    methods: {
      async getModels() {
        let vm = this
        await window.axios.post(`/ajax/get-favorite-models-by-project/${this.projectId}`, {
            localFavorites: window.getLocalFavorites()
        })
          .then(function (resp) {
            vm.models = resp.data.data.models;
            vm.loggedIn = resp.data.data.loggedIn;
          })
          .catch(function () {
            vm.showLoading = false
          });
      },
      deleteFavoriteModel(id) {
        let vm = this;
        if(vm.loggedIn) {
            window.axios.delete(`/ajax/favorites/${id}/model`)
                .then(function () {
                    vm.models.forEach(function (model, key) {
                        if (model.id === id) {
                            vm.models.splice(key, 1);
                        }
                    });
                    window.Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        html: 'Modelul a fost sters din lista de favorite.',
                        showConfirmButton: false,
                        timer: 1500
                    })
                })
                .catch(function (err) {
                    window.showError(err)
                });
        } else {
            vm.models.forEach(function (model, key) {
                if (model.id === id) {
                    vm.models.splice(key, 1);
                }
            });

            let favorites = window.getLocalFavorites();
            favorites = favorites.filter(
                fav => !(
                    fav.favoritable_type === "App\\ProjectModel" &&
                    fav.favoritable_id === id
                )
            );
            window.saveLocalFavorites(favorites);

            window.Swal.fire({
                position: 'top-end',
                icon: 'success',
                html: 'Modelul a fost sters din lista de favorite.',
                showConfirmButton: false,
                timer: 1500
            });
        }
      }
    }
  }
</script>

<style scoped>

</style>
